import qs from "qs";

export const isSuperAdmin = (user) => {
    if (user === null) return false;
    return user?.is_super === 1;
};

export const isLevel1User = (user) => {
    if (user === null) return false;
    return user?.parent_id === 0 && `${user?.role?.level}` === `${1}`;
};

// export const isLevel2User = (user) => {
//     if (user === null) return false;
//     return user?.role?.level === 2;
// }

export const isLevel3User = (user) => {
    if (user === null) return false;
    // console.log(user?.role);
    return `${user?.role?.level}` === `${3}`;
};

export const scrollToTop = () => {
    window.scrollTo({
        top: 0, behavior: 'smooth'
    });
};

export function urlToSearchState({search}) {
    return qs.parse(search.slice(1));
}

export function formatDate(date) {
    if (date === undefined) return '';
    if (date === null) date = new Date();
    const d = new Date(date);
    const monthArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${monthArr[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
}

export function emptyIfNull(value) {
    if (value === null || value === undefined || isNaN(value)) return '';
    return value;
}

export function numDaysBetween(d1, d2) {
    const diff = Math.abs(d1.getTime() - d2.getTime());
    return diff / (1000 * 60 * 60 * 24);
};
